import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "excess-return-vendor",
  value: "Excess_Return_To_Vendor",
  labelKey: "inventory.transferExcessReturnToVendor",
  party: "vendor",
};

export function ExcessReturnToVendorModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
